import React from 'react';
import { motion } from 'framer-motion';
import { useModal } from '../services/ModalService';
import '../styles/pages/Staffing.css';

const Staffing = () => {
  const { openContactModal } = useModal();

  return (
    <div className="staffing-page">
      {/* Hero Section */}
      <section className="staffing-hero">
        <div className="staffing-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center" }}
          >
            <div className="hero-badge">
              👥 Elite Talent Solutions
            </div>

            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Strategic <span class=\"gradient-text\">Staffing Solutions</span><br />for Growing Businesses" }}
            />

            <p className="hero-subtitle">
              Connect with exceptional professionals across technology, finance, and business sectors. Our comprehensive staffing solutions help you build high-performing teams that drive results.
            </p>

            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={() => openContactModal(
                  'Talent Acquisition Services',
                  'Staffing Page - Find Talent'
                )}
              >
                Find Talent
              </button>
              <button
                className="btn-secondary"
                onClick={() => openContactModal(
                  'Position Posting Services',
                  'Staffing Page - Post Position'
                )}
              >
                Post Position
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="staffing-section">
        <div className="staffing-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="staffing-section-title gradient-text">Professional Staffing Services</h2>
            <p className="staffing-section-subtitle">
              Connect with top-tier professionals to build your dream team across multiple industry sectors
            </p>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '30px',
              marginTop: '60px'
            }}>
              <div className="staffing-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>IT Professionals</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Skilled software developers, DevOps engineers, data scientists, and IT specialists with proven expertise in modern technologies.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Full-Stack Developers</li>
                  <li style={{ marginBottom: "8px" }}>✓ DevOps & Cloud Engineers</li>
                  <li style={{ marginBottom: "8px" }}>✓ Data Scientists & Analysts</li>
                  <li style={{ marginBottom: "8px" }}>✓ IT Support Specialists</li>
                </ul>
              </div>

              <div className="staffing-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Financial Experts</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Certified accountants, financial analysts, bookkeeping professionals, and accounting specialists with industry certifications.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Certified Public Accountants</li>
                  <li style={{ marginBottom: "8px" }}>✓ Financial Analysts & Controllers</li>
                  <li style={{ marginBottom: "8px" }}>✓ Bookkeeping Specialists</li>
                  <li style={{ marginBottom: "8px" }}>✓ Tax Preparation Experts</li>
                </ul>
              </div>

              <div className="staffing-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Project Managers</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Experienced project managers with PMP, Agile, and Scrum certifications to lead your initiatives to successful completion.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ PMP Certified Managers</li>
                  <li style={{ marginBottom: "8px" }}>✓ Agile & Scrum Masters</li>
                  <li style={{ marginBottom: "8px" }}>✓ Technical Program Managers</li>
                  <li style={{ marginBottom: "8px" }}>✓ Digital Transformation Leaders</li>
                </ul>
              </div>

              <div className="staffing-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Business Consultants</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Strategic consultants and business analysts to optimize your processes, drive growth, and implement efficient solutions.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Business Process Optimization</li>
                  <li style={{ marginBottom: "8px" }}>✓ Strategic Planning Consultants</li>
                  <li style={{ marginBottom: "8px" }}>✓ Operations Analysts</li>
                  <li style={{ marginBottom: "8px" }}>✓ Change Management Specialists</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="staffing-section">
        <div className="staffing-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="staffing-cta-card">
              <h3 style={{
                fontSize: "2rem",
                marginBottom: "20px",
                color: "#8B5CF6"
              }}>
                Ready to Build Your Dream Team?
              </h3>
              <p style={{
                fontSize: "1.1rem",
                marginBottom: "30px",
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto 30px"
              }}>
                Let us help you find the right professionals to drive your business forward. Quality talent, competitive rates, proven results.
              </p>
              <div style={{ display: "flex", gap: "20px", justifyContent: "center", flexWrap: "wrap" }}>
                <button
                  className="btn-primary"
                  onClick={() => openContactModal(
                    'Hiring Services',
                    'Staffing Page - Start Hiring'
                  )}
                >
                  Start Hiring
                </button>
                <button
                  className="btn-secondary"
                  onClick={() => openContactModal(
                    'Staffing Consultation',
                    'Staffing Page - Schedule Consultation'
                  )}
                >
                  Schedule Consultation
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Staffing;
